import React from 'react';
import styled from 'styled-components';
import Text from 'components/Text';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import HeroInlineProgressiveForm from '../../Form/ProgressiveForm/HeroInlineProgressiveForm';

const HeroWithProgressiveForm = ({ background, title, description, revealProps, otherProps }) => {
  return (
    <SectionContainer background={background} {...otherProps}>
      <div className="section-review-hero--container">
        <h2 className="section-review-hero--title">{title}</h2>
        {description && (
          <Text type="p" size="large" className="section-review-hero--description">
            {description.json ? documentToReactComponents(description.json) : description}
          </Text>
        )}
        <HeroInlineProgressiveForm dataPosition="Hero" revealProps={revealProps} />
      </div>
    </SectionContainer>
  );
};

export default HeroWithProgressiveForm;

const SectionContainer = styled.div`
  background: ${({ background }) => background};

  .section-review-hero--container {
    margin: 0 auto;
    padding: 40px 0;

    .section-review-hero--title {
      font-size: 61px;
      font-weight: 900;
      line-height: 110%;
      text-align: center;
      letter-spacing: -0.05em;
      max-width: 914px;
      margin: 0 auto !important;
      padding: 0 28px;
      @media (max-width: 768px) {
        padding: 0;
      }
    }

    .section-review-hero--description {
      text-align: center;
      max-width: 900px;
      margin: 0 auto;
      margin-top: 50px;
      padding: 0 28px;
      font-size: 25px;
      @media (max-width: 768px) {
        padding: 0;
      }
    }
  }

  @media (max-width: 768px) {
    .section-review-hero--container {
      .section-review-hero--title {
        font-size: 36px;
        line-height: 44px;
        max-width: 590px;
      }

      .section-review-hero--description {
        font-size: 18px;
        line-height: 28px;
        margin-top: 20px;
        max-width: 590px;
      }
    }
  }

  @media (max-width: 576px) {
    .section-review-hero--wrapper {
      height: 610px;
    }

    .section-review-hero--container {
      .section-review-hero--title {
        font-size: 36px;
        line-height: 42px;
      }

      .section-review-hero--description {
        font-size: 20px;
        line-height: 28px;
        margin-top: 20px;
      }
    }
  }
`;
